import { FC, useState } from "react";
import { Navigate } from "react-router-dom";
import { IUser } from "../types/reducers/authReducer";
import { getDefaultLandingPage } from "../utils/permissions";
import { isPublicNext } from "../next/public/mode";
import { takeWantedPage } from "../utils/wantedPage";

/**
 * Walkthrough M6: a signed-in person on a sign-in page goes back to the page that was wanted (an e-mailed download link opened while
 * signed out), else to the usual landing page. The wanted page is read once, on mount, so a re-render cannot send him elsewhere.
 */
export const ToWantedOrLanding: FC<{ user: IUser }> = ({ user }) => {
  const [to] = useState(() => (isPublicNext() ? takeWantedPage() : null) ?? getDefaultLandingPage(user));
  return <Navigate to={to} replace />;
};
